export enum EAiIntegrationProvider {
  Gpt = 0,
  Cloud = 1,
}
